import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DataPersistenceService } from '../data-persistence/data-persistence.service';

// UX gate only: the API must still reject requests without a valid token.
export const authGuard: CanActivateFn = () => {
  if (environment.features.requireAuth === false) {
    return true;
  }
  return !!inject(DataPersistenceService).getAccessToken() || inject(Router).createUrlTree(['/unauthorized']);
};
